import React from "react";
import {
  UserAvatar,
  UserDetails,
  UserDetailsHeader,
  UserDetailsMain,
  UserImage,
  UserPageContainer,
  UserSettingsSidebar,
  UserSettingsWrapper,
} from "./UserPageStyle";

import TempImage from "../../images/chat_background.jpg";

const UserPage = () => {
  return (
    <UserPageContainer>
      <h1>Hello you can customise your user info here!</h1>
      <UserSettingsWrapper>
        <UserSettingsSidebar>
          <h1>i am sidebar hello!!</h1>
        </UserSettingsSidebar>
        <UserDetails>
          <UserDetailsHeader>
            <UserImage
              style={{
                backgroundImage: `url(${TempImage})`,
              }}
            ></UserImage>
          </UserDetailsHeader>
          <UserDetailsMain>Hello I am details!</UserDetailsMain>
        </UserDetails>
      </UserSettingsWrapper>
    </UserPageContainer>
  );
};

export default UserPage;
